import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IMembershipGeneralDetailsCategoryListResponse } from "@/api_framework/api_modals/Membership";
import { setMembershipCategoryList } from "@/app_redux/reducers/slices/auth/membership.slice";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

AxiosCurlirize(axios, () => {});

export const useMembershipCategoryListingAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(MEMBERSHIP_MODULE?.MEMBERSHIP_CATEGORY_LIST?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IMembershipGeneralDetailsCategoryListResponse>) => {
          if (res.data.status === true) {
            dispatch(setMembershipCategoryList({ data: res.data.data }));
          } else {
            dispatch(setMembershipCategoryList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        captureError(error);
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch]);

  return execute;
};
